import $ from 'jquery'

const pageTriggerId = '#single-product'

const triggerElementShowData = '.js-btn-show-table'
const showHideElement = '.wrapper-show-hide'

const ProductView = {
  initToggleEvent: function() {
    $(triggerElementShowData).on('click', (e) => {
      e.preventDefault()
      const switchButton = $(triggerElementShowData)
      const btnTxtClosed = switchButton.data('label-show')
      const btnTxtOpened = switchButton.data('label-hide')

      $(showHideElement).slideToggle('slow', function() {
        if ($(this).is(':visible')) {
          switchButton.text(btnTxtOpened)
        } else {
          switchButton.text(btnTxtClosed)
        }
      })
    })
  },

  init: function() {
    if (document.querySelector(pageTriggerId) !== null) {
      this.initToggleEvent()
    }
  }
}

export default ProductView



// WEBPACK FOOTER //
// ./app/components/product/productView.js